import { render, staticRenderFns } from "./MonitoringHutang.vue?vue&type=template&id=70b32231"
import script from "./MonitoringHutang.vue?vue&type=script&lang=js"
export * from "./MonitoringHutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports